import {
    EMPTY_DEFAULT,
    EMPTY_FILTERED,
    EMPTY_SEARCH,
} from '../../components/VacationDpTable/vacationDpTable.definitions';
import type { DpEmptyReason } from '../../hooks/useVacationDpBoard';

export const PAGE_TITLE = 'Gestão de férias';
export const PAGE_SUBTITLE =
    'Situação de férias de todo o time: saldos, limites para aprovar e solicitações a decidir.';

export const TAB_COLLABORATORS = 'Colaboradores';
export const TAB_CLIENT = 'Conflitos';
export const TAB_HISTORY = 'Histórico';
export const TAB_PAID_REST = 'Descanso de PJ';
export const TAB_HOLIDAYS = 'Feriados';

export const SEARCH_PLACEHOLDER = 'Buscar por nome ou e-mail';
export const SEARCH_LABEL = 'Buscar colaborador';

export const MONTH_FILTER_LABEL = 'Mês';

export const EMPTY_MONTH = 'Nenhum colaborador de férias neste mês.';

export const ACCESS_DENIED_TITLE = 'Acesso ainda não liberado';
export const ACCESS_DENIED_MESSAGE =
    'Seu perfil tem permissão para este painel, mas ela ainda não chegou a este dispositivo. Saia e entre novamente para atualizar suas credenciais.';

export const LOAD_ERROR_TITLE = 'Não foi possível carregar o painel';
export const LOAD_ERROR_MESSAGE = 'Verifique sua conexão e tente novamente.';

export function buildResultLabel(visibleCount: number, totalCount: number): string {
    if (visibleCount === totalCount) {
        return `${totalCount} ${totalCount === 1 ? 'colaborador' : 'colaboradores'}`;
    }
    return `${visibleCount} de ${totalCount} colaboradores`;
}

export const EMPTY_MESSAGES: Record<DpEmptyReason, string> = {
    none: '',
    search: EMPTY_SEARCH,
    month: EMPTY_MONTH,
    filter: EMPTY_FILTERED,
    base: EMPTY_DEFAULT,
};
